import { View, html } from 'rune-ts';
import klass from './LnbCreatorShop24View.module.scss';
import { TabCreatorShopView } from '@services/MarppleShop/shared/components/atoms/Tabs/TabCreatorShopView.ts';
import { ECreatorShopLnbMenu } from '@services/MarppleShop/shared/enum/ECreatorShopLnbMenu.ts';
import { font } from '@services/MarppleShop/shared/typography';
import { classes } from '@services/MarppleShop/shared/util';
import { makePlusUrl } from '@services/MarppleShop/shared/util/url.ts';

type TLnbCreatorShop24ViewProps = {
  menus: {
    key: ECreatorShopLnbMenu;
    url: string;
    name: string;
    is_selected: boolean;
    count?: number;
  }[];
  plus_domain: string | undefined;
};

export class LnbCreatorShop24View extends View<TLnbCreatorShop24ViewProps> {
  protected override template({ menus, plus_domain }: TLnbCreatorShop24ViewProps) {
    return html`<nav class="${klass.lnb_creator_shop_2_4}">
      <ul class="${klass.menu_list}">
        ${menus.map(
          (menu) =>
            html`<li>
              ${new TabCreatorShopView({
                menu_title:
                  (menu.key === ECreatorShopLnbMenu.FanLetter || menu.key === ECreatorShopLnbMenu.Review) &&
                  menu.count &&
                  menu.count > 0
                    ? html`<span class="${font('18_medium')}">${menu.name}</span
                        ><span class="${classes(font('12_regular'), klass.count)}">${menu.count}</span>`
                    : menu.name,
                state: menu.is_selected ? 'Select' : 'Unselect',
                device: 'PC',
                href: makePlusUrl(plus_domain, menu.url),
              })}
            </li>`,
        )}
      </ul>
    </nav>`;
  }
}
